import { getCountryInfo } from '../../utils/countries';

const CountryDisplay = ({ countryCode, city, className = '' }) => {
  const country = getCountryInfo(countryCode, city);
  
  if (!country) return null;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img 
        src={country.flag} 
        alt={country.displayName}
        className="w-6 h-6 rounded-full object-cover"
      />
      <span>{city}</span>
    </div>
  );
};

export default CountryDisplay;
